import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CustomInput from '../../components/CustomInput/CustomInput';
import PermissionTable from './permissionTable';

import CustomSelect from '../../components/CustomSelectOut/CustomSelectOut';
import SidePanel from '../../components/SidePanel/SidePanel';

const useStyles = makeStyles(() => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    '& + &': {
      marginTop: 20,
      paddingTop: 16,
      borderTop: '1px solid #EEF1F6',
    },
  },
  sectionTitle: {
    margin: '8px 0 4px',
    fontSize: 13,
    fontWeight: 600,
    color: '#5B6472',
  },
  checkBoxForm: {
    display: 'flex',
    marginLeft: 0,
    marginRight: 0,
    justifyContent: 'space-between',
  },
}));

const EXTERNAL_ROLE_TYPES = [{ id: 1, name: 'External Valuer' }, { id: 2, name: 'Contractor' }];

export default function OnBoardingDialog({
  open, handleClose,
  roleID,
  roleName,
  externalUser,
  externalRole,
  roleDescription,
  handleSaveData,
}) {
  const classes = useStyles();
  const [desc, setDesc] = useState(roleDescription);
  const [role, setRole] = useState(roleName);
  const [isExternalUser, setIsExternalUser] = useState(externalUser);
  const [externalRoleType, setExternalRoleType] = useState(externalRole || -1);
  const [permissions, setPermissions] = useState(roleName);

  // Same checks as the old two-step form.
  const handleSave = () => {
    if (role.length < 1) {
      toast.error('Role can not be empty.');
      return;
    }
    handleSaveData(roleID, role, desc, isExternalUser, externalRoleType, permissions);
  };

  return (
    <SidePanel
      open={open}
      setOpen={(value) => { if (!value) handleClose(false); }}
      title={roleID ? 'Edit role' : 'Add role'}
      width={760}
      actionLabel={roleID ? 'Update' : 'Save'}
      handleSaveData={handleSave}
      body={(
        <>
          <section className={classes.section}>
            <h3 className={classes.sectionTitle}>Basic details</h3>
            <CustomInput
              id='role'
              label='Role'
              value={role}
              onChange={(id) => {
                setRole(id.target.value);
              }}
            />
            <CustomInput
              id='desc'
              label='Description'
              multiline
              rows={4}
              value={desc}
              onChange={(id) => {
                setDesc(id.target.value);
              }}
            />
            <FormControlLabel
              className={classes.checkBoxForm}
              control={(
                <Checkbox
                  disabled={roleID}
                  checked={isExternalUser}
                  onChange={(event) => setIsExternalUser(event.target.checked)}
                  name='Is External User'
                />
              )}
              label='Is External User'
              labelPlacement='start'
            />

            {isExternalUser ? (
              <CustomSelect
                disabled={roleID}
                id='subscriberId'
                title='External Role Type'
                menuItems={EXTERNAL_ROLE_TYPES.map((element) => (
                  <option value={element.id} key={element.id}>{element.name}</option>
                ))}
                handleChange={(event) => {
                  setExternalRoleType(event.target.value !== '#78' ? event.target.value : -1);
                }}
                value={externalRoleType}
              />
            ) : null}
          </section>
          <section className={classes.section}>
            <h3 className={classes.sectionTitle}>Role permissions</h3>
            <PermissionTable
              roleID={roleID}
              isExternalUser={isExternalUser}
              setPermissions={(perm) => setPermissions(perm)}
            />
          </section>
        </>
      )}
    />
  );
}
